// A busca do backend olha o código e o nome (description) do desconto. O Padrão não tem nome: o cartão o chama
// "Padrão de Posto Centro". Quem digita esse título (ou só o nome do posto) quer ver o Padrão daquele posto, então a
// busca vira filtro: tipo Padrão e/ou o posto. Texto que não tem cara de título de Padrão nem de posto segue como busca.
import { norm } from '../v2/format'

export interface SearchRoute {
  /** true = filtrar pelo tipo Padrão. */
  onlyDefault: boolean
  placeId?: string
}

interface Named { id: string; name: string }

const DEFAULT_WORD = /^padrao(\s+de|\s+do|\s+da)?\s*/
const MIN_CHARS = 3

/**
 * "Padrão de Posto Centro" -> Padrão + o posto; "Padrão" -> só Padrão; "Posto Centro" (o nome inteiro de um posto) -> o posto.
 * Nome de posto só vale por inteiro: um pedaço ("centro") pode ser o nome de uma promoção.
 */
export const routeSearch = (typed: string, stations: Named[]): SearchRoute | null => {
  const text = norm(typed).trim().replace(/\s+/g, ' ')
  if (text.length < MIN_CHARS) return null
  const byName = (value: string) => stations.filter(s => norm(s.name).trim().replace(/\s+/g, ' ') === value)
  const exact = byName(text)
  if (exact.length === 1) return { onlyDefault: false, placeId: exact[0].id }
  if (!DEFAULT_WORD.test(text)) return null
  const rest = text.replace(DEFAULT_WORD, '').trim()
  if (!rest) return { onlyDefault: true }
  const named = byName(rest)
  if (named.length === 1) return { onlyDefault: true, placeId: named[0].id }
  const part = stations.filter(s => norm(s.name).includes(rest))
  return part.length === 1 ? { onlyDefault: true, placeId: part[0].id } : null
}
